(function () {
  var navToggle = document.querySelector('[data-lc-nav-toggle]');
  var navPanel = document.querySelector('[data-lc-nav-panel]');

  if (navToggle && navPanel) {
    navToggle.addEventListener('click', function () {
      var isOpen = navPanel.getAttribute('data-open') === 'true';
      navPanel.setAttribute('data-open', String(!isOpen));
      navToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  document.querySelectorAll('[data-lc-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-lc-slider-track]');
    var slides = slider.querySelectorAll('[data-lc-slide]');
    var prev = slider.querySelector('[data-lc-slider-prev]');
    var next = slider.querySelector('[data-lc-slider-next]');
    var dots = slider.querySelectorAll('[data-lc-slider-dot]');
    var mobileCards = slider.querySelectorAll('[data-lc-mobile-card]');
    var autoplay = Number(slider.getAttribute('data-lc-slider-autoplay')) || 0;
    var index = 0;
    var timer = null;

    if (!track || slides.length < 2) {
      return;
    }

    function setSlide(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(' + index * -100 + '%)';
      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      mobileCards.forEach(function (card, cardIndex) {
        var isActive = cardIndex === index;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-hidden', String(!isActive));
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        setSlide(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setSlide(index + 1);
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        setSlide(dotIndex);
      });
    });

    setSlide(0);

    if (autoplay > 0) {
      timer = window.setInterval(function () {
        setSlide(index + 1);
      }, autoplay);

      slider.addEventListener('mouseenter', function () {
        window.clearInterval(timer);
      });

      slider.addEventListener('mouseleave', function () {
        timer = window.setInterval(function () {
          setSlide(index + 1);
        }, autoplay);
      });
    }
  });
})();
